import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { PickupPointBlockEmail } from "./email";
import type { PickupPointBlockProps } from "./types";


export function PickupPointBlockEditor(props: PickupPointBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <PickupPointBlockEmail {...props} isEditor />
    </EmailComponentWrapper>
  );
}
